import React from "react";

/**
 * Brand logo wrapper. Two variants:
 *   variant="full" (default) — horizontal wordmark (dark text). Best on light
 *     backgrounds (e.g. footer, blog cards).
 *   variant="icon" — icon-only OE mark (octagon + 3 bars). Best on dark
 *     backgrounds like the navbar where the wordmark would be illegible.
 *
 * Usage:
 *   <BrandLogo variant="icon" className="h-11 w-auto" priority />
 *   <BrandLogo className="h-14 w-auto" />
 */
const VARIANTS = {
  full: { src: "/brand/oxford-ec-horizontal-web.png", w: 800, h: 218 },
  icon: { src: "/brand/oxford-ec-icon-web.png", w: 800, h: 427 },
  "full-white": { src: "/brand/oxford-ec-horizontal-white-web.png?v=2", w: 800, h: 203 },
  "full-teal": { src: "/brand/oxford-ec-horizontal-teal-web.png?v=2", w: 800, h: 203 },
  "icon-white": { src: "/brand/oxford-ec-icon-white.webp", w: 800, h: 427 },
};

export default function BrandLogo({
  className = "",
  alt = "Oxford EC — Property Compliance Delivered Professionally",
  priority = false,
  variant = "full",
}) {
  const v = VARIANTS[variant] || VARIANTS.full;
  return (
    <img
      src={v.src}
      alt={alt}
      width={v.w}
      height={v.h}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding="async"
      className={className}
      data-testid="brand-logo"
    />
  );
}
